export default{
  "language": "pt",
  "message":
    {
      "title": "Calculadora de bônus habitacional de renda mista",
      "zoningDistrict": "Selecione o distrito de zoneamento",
      "affordabilityLevel": "Selecione um nível de acessibilidade",
      "allThatApply": "Selecione todas as opções aplicáveis.",
      "springGardenS": "O projeto está localizado ao sul da Spring Garden Street?",
      "yes": "sim",
      "no": "Não",
      "affordability": {
        "lowIncome": "Baixa renda",
        "moderateIncome": "Renda moderada",
      },
      "lotAreaSqft": "Insira a área do lote em pés quadrados",
      "buildingHeight": "Insira a altura do edifício",
      "totalUnits": "Número proposto de unidades em projeto:",
      "unitsEarnedLow": "Unidades adicionais ganhas (baixa renda):",
      "unitsEarnedMod": "Unidades adicionais ganhas (renda moderada):",
      "greenRoofBonus": "Número de unidades de bônus Green Roof:",
      "modIncomePayment": "Pagamento estimado de renda moderada:",
      "lowIncomePayment": "Pagamento estimado de baixa renda:",
      "requiredAffordableUnits": "Total de unidades acessíveis necessárias:",
      "requiredMinAffordableUnits": "Unidades acessíveis obrigatórias/mínimas:",
      "totalRequiredAffordabilityUnits": "Total de unidades acessíveis necessárias:",
      "additionalFar": "FAR adicional obtido:",
      "totalFar": "FAR total:",
      "totalFloor": "Área total permitida:",
      "overlay": {
        "fithDistrict": "Este projeto está dentro do Fifth District Overlay District (/VDO).",
        "greenRoof": "Este projeto ganhará um bônus Green Roof.",
        "minMixed": "Este projeto está dentro da sobreposição de bairros de renda mista /MIN. ",
        "todDevelopement": "Este projeto está dentro do /TOD Transit Oriented Development Overlay.",
      },
      "sFHA": [
        "Área Especial de Risco de Enchente",
      ],
      "numberOfDwellingUnits": "Número de unidades habitacionais permitidas pelo zoneamento básico:",
      "about": "Sobre",
      "aboutTitle": "Sobre o bônus habitacional de renda mista",
      "aboutSubTitle": "Como usar a calculadora",
      "paragraphOne": "O bônus habitacional de renda mista é para incorporadores que adicionam moradias acessíveis a seus projetos ou pagam um fundo que apóia moradias populares. Em troca, o desenvolvimento obtém mais área útil, altura e/ou unidades habitacionais “à direita”. Os desenvolvedores podem escolher entre dois níveis de bônus. O nível de renda moderado é um bônus menor, mas tem padrões de acessibilidade menos rígidos ou um valor de pagamento menor. O baixo nível de renda é um bônus maior, mas tem padrões de acessibilidade mais rígidos ou um valor de pagamento mais alto.",
      "paragraphTwo": {
        "text": "A calculadora de bônus habitacional de renda mista é usada para estimar com precisão o:",
        "bullets": [
          "Número total de unidades permitidas.",
          "Número total de unidades acessíveis que você deverá fornecer.",
          "Taxa em vez do valor a ser pago por um desenvolvimento que usa o bônus habitacional de renda mista.",
        ],
      },
      "paragraphThree": {
        "text": "Para começar, selecione o distrito de zoneamento básico da propriedade e insira a área do lote. Você também deve selecionar quaisquer distritos de sobreposição aplicáveis. Você pode usar",
        "link": {
          "text": "Atlas",
          "p": {
            "url": "https://atlas.phila.gov/",
          },
        },
        "continuation": "para encontrar essa informação.",
      },
      "finalConfirmation": "Esta calculadora deve ser usada para o planejamento conceitual do projeto. Onde houver uma discrepância entre a calculadora e o Código de Zoneamento da Filadélfia, o Código de Zoneamento da Filadélfia prevalecerá. A confirmação final das unidades, o número necessário de unidades acessíveis e/ou o valor da taxa substitutiva serão feitas pela equipe da Comissão de Planejamento da Cidade da Filadélfia durante a revisão da licença de zoneamento. ",
      "resources": "Recursos",
      "code1": {
        "link": {
          "text": "Código da Filadélfia — 14-702 (7) — Bônus de habitação de renda mista",
          "p": {
            "url": "https://codelibrary.amlegal.com/codes/philadelphia/latest/philadelphia_pa/0-0-0-293117",
          },
        },
      },
      "code2": {
        "link": {
          "text": "Código da Filadélfia — 14-533 — Distrito de sobreposição de bairro de renda mista",
          "p": {
            "url": "https://codelibrary.amlegal.com/codes/philadelphia/latest/philadelphia_pa/0-0-0-291906",
          },
        },
      },
      "facts": {
        "link": {
          "text": "Fichas técnicas de bônus habitacionais de renda mista",
          "p": {
            "url": "https://www.phila.gov/documents/affordable-housing-zoning-bonus-review-application/",
          },
        },
      },
    },
};